<template>
  <div>
    <div :class="className" :id="id" :style="{ height: height, width: width }"></div>
  </div>
</template>

<script>
export default {
  name: "AreaLine",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "300px"
    },
    chartData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showPie: false,
      pie: null
    };
  },
  mounted() {
    setTimeout(() => {
      this.initChart();
    }, 800);
  },
  methods: {
    initChart() {
      this.pie = this.$highcharts.chart(this.id, {
        chart: {
          type: 'area',
          spacingBottom: 30,
          backgroundColor: "rgba(0,0,0,0)"
        },
        title: {
          text: "" //图表的标题文字
        },
        subtitle: {
          text: "" //副标题文字
        },
        colors: ["#1d89ff","#85e9ef"],
        legend: {
          itemStyle: {
            color: "#cbeeff",
            fontSize: 12
          },
          itemHoverStyle: {
            color: "#ccc"
          }
        },
        xAxis: {
          categories: this.chartData.nameList,
          endOnTick: true,
          labels: {
            style: { "color": "#cbeeff", "cursor": "default", "fontSize": "11px" },
            formatter: function () {
              return this.value;
            }
          }
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            style: { "color": "#cbeeff", "cursor": "default", "fontSize": "11px" },
            formatter: function () {
              return this.value;
            }
          }
        },
        tooltip: {
          pointFormat: '{series.name}  <b>{point.y:,.0f} 次</b>'
        },
        plotOptions: {
          area: {
            fillOpacity: 0.3, // 指定所有面积图的透明度
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true
                }
              }
            }
          }
        },
        series: this.chartData.data
      });
      document.getElementsByClassName("highcharts-credits")[0].innerHTML = "";
      this.showPie = true;
    }
  }
};
</script>
<style scoped lang="less">
</style>
